import { render, staticRenderFns } from "./ShowEvent.vue?vue&type=template&id=3ca41c85&scoped=true&slot=tag&slot-scope=props&"
import script from "./ShowEvent.vue?vue&type=script&lang=js&"
export * from "./ShowEvent.vue?vue&type=script&lang=js&"
import style0 from "./ShowEvent.vue?vue&type=style&index=0&id=3ca41c85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca41c85",
  null
  
)

export default component.exports